import type { SportProfile } from '@/types'

export const soccerWomens: SportProfile = {
  id: 'soccer-womens',
  sport: 'soccer',
  gender: 'womens',
  environment: 'outdoor',
  label: "Women's Soccer",
  emoji: '⚽',
  playersOnField: 11,
  contactLevel: 'limited',
  hasShotClock: false,
  periods: { label: 'Half', count: 2, durationMinutes: 45 },
  positions: [
    { key: 'goalkeeper', label: 'Goalkeeper', shortLabel: 'GK', maxOnField: 1 },
    { key: 'defender',   label: 'Defender',   shortLabel: 'DEF' },
    { key: 'midfielder', label: 'Midfielder',  shortLabel: 'MID' },
    { key: 'forward',    label: 'Forward',     shortLabel: 'FWD' },
  ],
  stats: [
    { key: 'goal',         label: 'Goal',          shortLabel: 'G' },
    { key: 'assist',       label: 'Assist',         shortLabel: 'A' },
    { key: 'shot',         label: 'Shot',           shortLabel: 'SH' },
    { key: 'shot_on_goal', label: 'Shot on Goal',   shortLabel: 'SOG' },
    { key: 'save',         label: 'Save',           shortLabel: 'SV' },
    { key: 'yellow_card',  label: 'Yellow Card',    shortLabel: 'YC', statType: 'card' },
    { key: 'red_card',     label: 'Red Card',       shortLabel: 'RC', statType: 'card' },
    { key: 'foul',         label: 'Foul',           shortLabel: 'FL' },
    { key: 'corner',       label: 'Corner Kick',    shortLabel: 'CK' },
    { key: 'offside',      label: 'Offside',        shortLabel: 'OFF' },
    { key: 'opp_shot',     label: 'Opp Shot',       shortLabel: 'OPP', statType: 'opp-shot' },
  ],
}
